// Added by Jonghyung Lee on 2021-12-13
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { customStyles } from '@/components/worklist/WPSMonitoring/WPSMonitoringBox'

type ComponentTypes = 'wpsmonitoringbox'

export type WPSMonitoringBoxStyleTypes = {
    [key in ComponentTypes]: Record<string, any>
}

export const WPSMonitoringBoxStyles: WPSMonitoringBoxStyleTypes = {
    wpsmonitoringbox: customStyles
}

// Wrapper Component
export { default as WPSMonitoringBoxWrapper } from './WPSMonitoringBoxWrapper'
export * from './WPSMonitoringBoxWrapper'